var React = require('react');

function Chex (props) {
    return React.createElement("svg",props,[React.createElement("path",{"opacity":"0.2","d":"M34.1695 34.1695L55 25.5412L75.8305 34.1695L84.4588 55L75.8305 75.8305L55 84.4588L34.1695 75.8305L25.5412 55L34.1695 34.1695Z","stroke":"#ECE9E5","key":0}),React.createElement("path",{"opacity":"0.2","d":"M30.6339 30.6339L55 20.5412L79.3661 30.6339L89.4588 55L79.3661 79.3661L55 89.4588L30.6339 79.3661L20.5412 55L30.6339 30.6339Z","stroke":"#ECE9E5","key":1}),React.createElement("path",{"opacity":"0.2","d":"M16.4918 16.4918L55 0.541196L93.5082 16.4918L109.459 55L93.5082 93.5082L55 109.459L16.4918 93.5082L0.541196 55L16.4918 16.4918Z","stroke":"#ECE9E5","key":2})]);
}

Chex.defaultProps = {"width":"110","height":"110","viewBox":"0 0 110 110","fill":"none"};

module.exports = Chex;

Chex.default = Chex;
